module.exports = __webpack_public_path__ + "media/icons/warning-5ee52fb86bd3e589d142f5138c32cc79.svg";